import React, { useEffect } from "react";
import "@/App.css";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Authority from "@/components/landing/Authority";
import Technology from "@/components/landing/Technology";
import Footer from "@/components/landing/Footer";

function App() {
    useEffect(() => {
        document.title =
            "Oliva Implantes | Excelência em Reabilitação Oral e Implantes Dentários";
    }, []);

    return (
        <div className="App relative min-h-screen bg-ivory font-sans text-onyx">
            <Header />
            <main>
                <Hero />
                <Authority />
                <Technology />
            </main>
            <Footer />
        </div>
    );
}

export default App;
